import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext({
  language: 'en',
  toggleLanguage: () => {}
});

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem('mp_lang') : null;
    if (stored === 'en' || stored === 'hi') setLanguage(stored);
  }, []);

  const toggleLanguage = () => {
    setLanguage((prev) => {
      const next = prev === 'en' ? 'hi' : 'en';
      if (typeof window !== 'undefined') window.localStorage.setItem('mp_lang', next);
      return next;
    });
  };

  const value = useMemo(() => ({ language, toggleLanguage }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}


